import {Button, Dialog, Form, FormButton, FormField, FormSubmitHandler} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {
  bulkFinancingRatesFormSchema,
  BulkFinancingRatesFormValues,
} from '../schemas/bulkFinancingRatesFormSchema';
import {FinancingCellRates} from '../types/FinancingCellRates';

interface BulkFinancingRatesDialogProps {
  isOpen: boolean;
  selectedCount: number;
  onApply: (rates: FinancingCellRates) => void;
  onDelete: () => void;
  onClose: () => void;
}

export function BulkFinancingRatesDialog(props: BulkFinancingRatesDialogProps) {
  const handleSubmit: FormSubmitHandler<BulkFinancingRatesFormValues> = (values) => {
    props.onApply({
      nominalRate: String(values.nominalRate),
      apr: String(values.apr),
    });
    props.onClose();

    return Promise.resolve();
  };

  const handleDelete = () => {
    props.onDelete();
    props.onClose();
  };

  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onClose}
      title={i18n.t('page.vehicle.financingAndLeasing.bulkEditRates')}
      size="small"
    >
      <Form<BulkFinancingRatesFormValues>
        experimentalZodSchema={bulkFinancingRatesFormSchema}
        mode="onChange"
        onSubmit={handleSubmit}
      >
        {(control, formApi) => (
          <VStack spacing={3}>
            <Text color="secondary">
              {i18n.t('page.vehicle.financingAndLeasing.bulkEditRatesDescription', {
                count: props.selectedCount,
              })}
            </Text>
            <FormField
              control={control}
              name="nominalRate"
              type="number"
              label={i18n.t('page.vehicle.financingAndLeasing.nominalRate')}
              suffix="%"
              decimalPlaces={2}
              minStepperValue={0}
              isRequired
            />
            <FormField
              control={control}
              name="apr"
              type="number"
              label={i18n.t('page.vehicle.financingAndLeasing.apr')}
              suffix="%"
              decimalPlaces={2}
              minStepperValue={0}
              isRequired
            />
            <HStack justify="space-between" spacing={3}>
              <Button
                title={i18n.t('general.actions.delete')}
                variant="dangerOutlined"
                leftIcon="action/delete"
                aria-label={i18n.t('general.actions.delete')}
                onClick={handleDelete}
              />
              <HStack spacing={2}>
                <Button
                  title={i18n.t('general.actions.discard')}
                  variant="secondary"
                  onClick={props.onClose}
                />
                <FormButton
                  control={control}
                  type="submit"
                  title={i18n.t('general.actions.apply')}
                  isDisabled={!formApi.formState.isValid}
                />
              </HStack>
            </HStack>
          </VStack>
        )}
      </Form>
    </Dialog>
  );
}
